/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Recovery_Code_Instruction_3Inputs */



/**
* | output |
* | --- |
* | "Keep it separate from your other credentials" |
*
* @param {Auth_Recovery_Code_Instruction_3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_recovery_code_instruction_3 = /** @type {((inputs?: Auth_Recovery_Code_Instruction_3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Recovery_Code_Instruction_3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bewahre ihn separat von deinen anderen Zugangsdaten auf")
	return /** @type {LocalizedString} */ ("Keep it separate from your other credentials")
});